import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const LINKS = [
  { path: '/activos/configuracion/clasificacion/categorias', label: 'Categorías' },
  { path: '/activos/configuracion/clasificacion/subcategorias', label: 'Subcategorías' },
  { path: '/activos/configuracion/clasificacion/familias', label: 'Familias' },
  { path: '/activos/configuracion/clasificacion/jerarquia', label: 'Vista jerárquica' },
];

const ActivosClassificationNav = () => {
  const location = useLocation();

  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {LINKS.map((link) => {
        const active = location.pathname === link.path;
        return (
          <Link
            key={link.path}
            to={link.path}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
              active
                ? 'bg-teal-600 text-white'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {link.label}
          </Link>
        );
      })}
    </div>
  );
};

export default ActivosClassificationNav;
